import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { language, ModalBase } from 'curvy';
import { Task } from '@task-utils/types';
import { TaskRoutes } from '@task-utils/routes';
import { orders_translations } from '../orders.trans';
import { ScheduledOrderTemplateType } from '../orders.types';
import { User } from '@task-modules/users';


@Component({
  selector: 'task-edit-scheduled-order-dialog',
  encapsulation: ViewEncapsulation.None,
  template: `
    <task-scheduled-order-form [order]="sch_order" [on_flag_change]="on_flag_change" form-collector #scheduledOrderForm="collector">
    </task-scheduled-order-form>
    <div class="flex-row modal-footer">
		<button color="primary" (click)="cancel()">
			<i icon="clear"></i>
			{{ 'CANCEL' | trans }}
		</button>

		<button class="filled" color="secondary" (click)="done()" [disabled]="scheduledOrderForm.containsErrors()">
			<i icon="check"></i>
			{{ 'SAVE' | trans }}
		</button>

	</div>
    `,
    styles: [`

    .modal task-edit-scheduled-order-dialog {
        max-width: 620px;
        box-sizing: border-box;
        padding-bottom: 70px;
        position: relative;
    }
    @media only screen and (min-width: 601px) {

        /* .modal task-edit-scheduled-order-dialog .modal-footer {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
        } */
    }
    `]
})
export class EditScheduledOrderDialog extends ModalBase<ScheduledOrderTemplateType | Promise<ScheduledOrderTemplateType>, Task.ScheduledOrderTemplate> implements OnInit {
    sch_order: ScheduledOrderTemplateType;
    scheduled_order_flags: Task.LabelFlags[] = [];
    preventSoftClose = true;
    allowSubmit = true;

    ngOnInit() {
        if (this.injectedData instanceof Promise) {
            this.injectedData.then(res => {
                this.sch_order = res;
                this.init();
            });
        } else {
            this.sch_order = this.injectedData;
            this.init();
        }
        language.load_translations(orders_translations);
    }

    async init() {
        await this.load_scheduled_order_flags();
    }

    async load_scheduled_order_flags() {
        const res = await TaskRoutes.label_flags.api_label_flags_get_all(User.currentUser.company_id);

        if (res.data && Array.isArray(res.data)) {
            this.scheduled_order_flags = [];

            for (const flag of res.data) {
                if (flag.scheduled_orders && flag.status_id !== Task.LABEL_FLAG_STATUS.DELETED) {

                    const is_selected = this.sch_order.label_ids?.includes(flag.label_id!) ?? false;

                    this.scheduled_order_flags.push({
                        ...flag,
                        selected: is_selected
                    });
                }
            }
        }

        this.sch_order.scheduled_order_flags = this.scheduled_order_flags;

        if (!this.sch_order.label_ids) {
            this.sch_order.label_ids = [];
        }
    }

    on_flag_change = (flag: Task.LabelFlags) => {
        if (flag.selected) {
            if (!this.sch_order.label_ids.includes(flag.label_id!)) {
                this.sch_order.label_ids.push(flag.label_id!);
            }
        } else {
            this.sch_order.label_ids = this.sch_order.label_ids.filter(id => id !== flag.label_id);
        }
    }

    async done() {
        if(this.sch_order) {
            this.sch_order.label_ids = this.scheduled_order_flags.filter(f => f.selected).map(f => f.label_id);

            let res = await TaskRoutes.scheduled_orders_templates.api_scheduled_order_template_modify(
                this.sch_order.scheduled_orders_template_id,
                this.sch_order
            );
            this.submit(res.data);

        } else {
            this.submit(null);
        }
    }

    cancel() {
        this.submit(null);
    }
}
